import { useTranslation } from "react-i18next";
import { classNames } from "../../ui/styles/classNames";
import CommandLine from "./CommandLine";
import { useConnectorServerAddress } from "./useConnectorServerAddress";

/** A `dmw-connector` command this page shows: its arguments, and whether it is about this server. */
export interface ConnectorCommand {
  readonly args: string;
  /** A command about one server names it: a PC may be paired with several and, unless told, serves the one paired last (F118). */
  readonly aboutServer: boolean;
}

/**
 * `dmw-connector <args>`, with `--server <address>` for a command about this server. While the
 * address is unknown it shows nothing; without one configured, it says so instead of a command that
 * could reach another server.
 */
export default function ConnectorCommandLine({ command, className }: { command: ConnectorCommand; className?: string }) {
  const { t } = useTranslation();
  const server = useConnectorServerAddress();
  if (!command.aboutServer) return <CommandLine command={`dmw-connector ${command.args}`} className={className} />;
  if (server.kind === "loading") return null;
  if (server.kind === "not_configured") {
    return <p className={classNames("app-text-muted text-xs", className)}>{t("connectors.pairCommand.notConfigured")}</p>;
  }
  return <CommandLine command={`dmw-connector ${command.args} --server ${server.address}`} className={className} />;
}
